// utils/calendarUtils.js

export const slotTimes = [
    "08:00 AM", "10:00 AM", "12:00 PM",
    "02:00 PM", "04:00 PM", "06:00 PM", "08:00 PM",
  ];
  
  export function parseTimeTo24h(timeStr) {
    if (!timeStr) return null;

    const ampmMatch = timeStr.match(/^\s*(\d{1,2}):(\d{2})\s*([AaPp][Mm])\s*$/);
    if (ampmMatch) {
      const [, hour, minute, period] = ampmMatch;
      let hours = parseInt(hour, 10);
      const normalizedPeriod = period.toUpperCase();
      if (normalizedPeriod === 'PM' && hours !== 12) hours += 12;
      if (normalizedPeriod === 'AM' && hours === 12) hours = 0;
      return `${hours.toString().padStart(2, '0')}:${minute}`;
    }

    const twentyFourMatch = timeStr.match(/^\s*(\d{1,2}):(\d{2})\s*$/);
    if (twentyFourMatch) {
      const [, hour, minute] = twentyFourMatch;
      const hours = Math.min(Math.max(parseInt(hour, 10), 0), 23);
      return `${hours.toString().padStart(2, '0')}:${minute}`;
    }

    return null;
  }
  
  export function combineDateTime(date, timeStr) {
    const parsed = parseTimeTo24h(timeStr);
    if (!parsed) return null;
    const [hour, minute] = parsed.split(':');
    const newDate = new Date(date);
    newDate.setHours(parseInt(hour));
    newDate.setMinutes(parseInt(minute));
    newDate.setSeconds(0);
    return newDate;
  }
  
  export function filterAvailableSlots({ date, bookedEvents }) {
    const selectedDate = new Date(date);
    const today = new Date().toDateString() === selectedDate.toDateString();
    const currentHour = new Date().getHours();
  
    return slotTimes.map((slot) => {
      const hour24 = parseInt(parseTimeTo24h(slot).split(':')[0]);
      const isBooked = bookedEvents.includes(hour24);
      const isPast = today && hour24 <= currentHour;
  
      return {
        time: slot,
        available: !isBooked && !isPast,
      };
    });
  }
  
